export default "__VITE_ASSET__D2PH3r7R__"